import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="36" height="36" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M22.5 12v12h-15V12h15zM24 9H6c-.825 0-1.5.675-1.5 1.5v15c0 .825.675 1.5 1.5 1.5h18c.825 0 1.5-.675 1.5-1.5v-5.25l6 6V9.75l-6 6V10.5c0-.825-.675-1.5-1.5-1.5z" fill="#54585D" /></svg>);